import request from '@/CommonDP/utils/request';
import { removeToken, storage } from '@/CommonDP/utils';

export function loginByUsername(params) {
  return request.post('/login', params).then((res) => res);
}

async function logout() {
  const store = require("@/store/index").default;
  try {
    await request.get('/logout').then((res) => {
      removeToken();
      var exdate = new Date();
      exdate.setDate(exdate.getDate() - 1000);
      document.cookie = "enterpriseId='' ;expires=" + exdate.toGMTString();
      store.dispatch('logoutRouter');
      store.dispatch('logoutInfo');
      store.dispatch('setHisOptions', []);
      store.dispatch('setDownFileList', []);
      store.dispatch('XtDesignUpdateNav', []);
      store.dispatch("setRouterNav", []);
      store.dispatch("setHasRoles", true);
      store.dispatch("setRepeatEnterpriseDept", true);
      const data = {
        createTime: "",
        enterPrjTime: "",
        prjCode: "",
        prjId: "",
        prjName: ""
      };
      store.dispatch("updatePrj", data);
      return res.data;
    });
  } catch (e) {
    console.debug(e);
  } finally {
    storage.remove("token");
    storage.remove("userId");
    storage.remove("userInfo");
  }
}

function getUserInfo() {
  return request.get(`/user/getUserInfo`);
}

// 用户系统权限模块
function getModuleList(enterpriseId) {
  return request.get(
    `/rolePermission/querySysUserPermissionAll?enterpriseId=${enterpriseId}`
  );
}
// 用户项目权限模块
function getModuleProjectList(enterpriseId, prjId) {
  return request.get(
    `/rolePermission/queryPrjUserPermissionAll?enterpriseId=${enterpriseId}&prjId=${prjId}`
  );
}

function getUserAvata() {
  return request.get('/pic/haveAvatar');
}

function onlineUserSave(params) {
  return request.get(`/public/system/onlineUser/save?prjId=${params.prjId || ''}&clientType=${params.clientType}`, params);
}
// 获取备案信息和版权信息
function getSystemFiling() {
  return request.get(`/system/getSystemFiling`);
}
// 获取用户直接单位
function queryCurrentUserDeptList(params) {
  return request(`/user/queryCurrentUserDeptList`, { params });
}

function getPublicSystemInfo() {
  return request.get(`/public/system/version`);
}

// 注销
async function logoff() {
  try {
    await request.post('/user/logoff');
    await logout();
  } catch (e) {
    console.debug(e);
  } 
}

export default {
  loginByUsername,
  getUserInfo,
  getModuleList,
  getUserAvata,
  logout,
  logoff,
  getModuleProjectList,
  onlineUserSave,
  getSystemFiling,
  queryCurrentUserDeptList,
  getPublicSystemInfo
};
